<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Links</h1>

      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>

      <div v-else v-for="(group, groupName) in links" :key="groupName">
        <h3 class="title is-3 group-name">{{ groupName }}</h3>
        <div v-for="link in group" :key="link.id">
          <a :href="link.link" target="_blank">{{ link.name }}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import LinksAPI from '@/services/api/Links';

export default {
  name: 'LinksPage',
  data() {
    return {
      loading: true,
      links: [],
    };
  },
  mounted() {
    LinksAPI.getAllLinks()
      .then(links => {
        this.links = _.groupBy(links, 'section');
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.group-name {
  margin-top: 30px;
}
</style>
